import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  serverUrl: 'https://help-api.stageflux.com',
  helpSiteUrl: 'https://help.stageflux.com',

  logging: {
    enabled: true,

    dsn: 'https://153db6e17636649cc3e2e03f874e9f6a@o4508320251445248.ingest.us.sentry.io/4508370557337600',
  },

  tracking: {
    enabled: true,
  },
};
